import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(private http: HttpClient) {
  }
  get lastLocations() { return JSON.parse(localStorage.getItem(this.lastLocatedKey) || '[]'); }
  set lastLocations(lastLocations: any[]) {
    if (lastLocations instanceof Array) {
      localStorage.setItem(this.lastLocatedKey, JSON.stringify(lastLocations));
    }
  }

  private readonly lastLocatedKey = 'location-service:located';
  _getCities: Promise<any[]>;
  async getCities() {
    if (this._getCities) return this._getCities;

    return new Promise<any[]>((resolve) => {
      this._getCities = this.http.get<any[]>(environment.app.assetsUrl + 'data/cities.json',
        { headers: { 'x-kp-alive': 'true' }, context: SharedService.NO_LOADING_BAR }).toPromise();
      this._getCities
        .catch(() => this._getCities = this.http.get<any[]>(environment.app.apiUrl + 'location/cities').toPromise())
        .finally(async () => resolve(await this._getCities));
    });
  }

  async getProvinces() {
    var cities = await this.getCities();
    return cities?.filter(_ => _.Importance == 2) || []; //ُTODO: ?
  }

  async stateEn(state: string) {
    const l = (await this.getCities())?.filter(_ => _.State == state).pop();
    if (l)
      return l.StateEn;
    return '';
  }
  async getCapital(state: string) {
    return (await this.getCities())?.filter(_ => _.State == state && _.Importance == 1).pop();
  }

  search(query: string) {
    return !query ? of([]) : this.http.get<any[]>(environment.app.apiUrl + 'location/search', { params: { query }, context: SharedService.NO_LOADING_BAR });
  }
}
